module.exports = __webpack_public_path__ + "img/home-pic-4.3463dc37.jpg";